import React, { useRef, forwardRef, useImperativeHandle } from "react";
import Styles from './styles.module.scss';

const CodeInput = forwardRef(({ length = 6, code, onChangeCode, hasError = false }, ref) => {
    const inputRefs = useRef([]);

    useImperativeHandle(ref, () => ({
        getCode: () => code.join('')
    }));

    const handleChange = (e, index) => {
        const value = e.target.value;

        if (value === '' || /^[0-9]$/.test(value)) {
            const newCode = [...code];
            newCode[index] = value;
            onChangeCode(newCode);

            if (value !== '' && index < length - 1) {
                inputRefs.current[index + 1]?.focus();
            }
        }

        if (value.length === length && /^[0-9]+$/.test(value)) {
            const arr = value.split('').slice(0, length);
            onChangeCode(arr);
            inputRefs.current[length - 1]?.focus();
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === 'Backspace') {
            if (code[index] === '' && index > 0) {
                inputRefs.current[index - 1]?.focus();
            }
        }
    };

    const handlePaste = (e) => {
        const paste = e.clipboardData.getData('text').slice(0, length).replace(/\D/g, '');
        if (paste.length === length) {
            const arr = paste.split('');
            onChangeCode(arr);
            inputRefs.current[length - 1]?.focus();
            e.preventDefault();
        }
    };

    return (
        <div className={Styles.codeInputWrap} onPaste={handlePaste}>
            {code.map((digit, index) => (
                <input
                    key={index}
                    type="text"
                    maxLength="1"
                    value={digit}
                    placeholder="•"
                    ref={(el) => (inputRefs.current[index] = el)}
                    onChange={(e) => handleChange(e, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    className={`${Styles.codeInput} ${hasError ? Styles.codeInputErr : ''}`}
                    inputMode="numeric"
                    pattern="[0-9]*"
                />
            ))}
        </div>
    );
});

export default CodeInput;

